import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  inputPlaceholder: {
    marginRight: "20px",
  },
  leftContainer: {
    display: "flex",
    alignItems: "center",
  },
  rightContainer: {
    display: "flex",
    alignItems: "end",
  },
}));

export default useStyles;
